import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";

export interface BatchNameTakenI{
    isDup: boolean
}

interface BatchQueryParams{
    batchName: string
}

export class GetBatchNameTaken extends GSEndpoint<{},BatchNameTakenI,BatchQueryParams> {
    constructor(batchName: string){
        super("hints/batch","GET",[], {batchName})
    }
    override async request(user: User): Promise<BatchNameTakenI>{
        return await super.makeRequest({},user)
    }
}
